<template>
    <button
        @click="$emit('click')"
        :class="buttonClass"
        :disabled="disabled"
        class="btn"
    >
        <slot v-if="!loading" />
        <ClipLoader :loading="loading" :color="spinnerColor" size="29px" />
    </button>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
	components: {
		ClipLoader
	},

	props: {
		transparent: Boolean,
		loading: Boolean,
		disabled: Boolean,
	},

	computed: {
		buttonClass() {
			return {
				'btn-primary': !this.transparent,
				'btn-link': this.transparent,
			};
		},
		spinnerColor() {
			return this.transparent ? '#0774E7' : '#FFF';
		}
	}
};
</script>

<style lang="scss" scoped>
.v-spinner {
	display: flex;
	align-items: center;
	justify-content: center;
}

.btn {
	font-weight: 600;
	font-size: 16px;
	min-width: 100%;
	line-height: 2;
	border-radius: 32px;

	&:focus {
		outline: 0;
		box-shadow: none;
	}
}

.btn.disabled,
.btn:disabled {
	opacity: 1;
	background: #C5CED7;
}

.btn-primary {
	border: none;
	background: #0774E7;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #0774E7;
		border-color: #0774E7;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}

.btn-primary:hover:not(:disabled):not(.disabled) {
    background-color: #115297;
}

.btn-link {
	border: 1.5px solid #0774E7;
	color: #0774E7;
	background-color: transparent;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #F2F4F8;
		border: 1px solid #6D7783;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}

.btn-link:hover {
	background-color: #0774E71F;
	border-color: #115297;
	color: #115297;
	text-decoration: none;
}

.btn-success {
	border: none;
	background: #009E55;

	&:not(:disabled):not(.disabled):active,
	&:not(:disabled):not(.disabled).active {
		background-color: #009E55;
		border-color: #009E55;
	}

	&:not(:disabled):not(.disabled):active:focus,
	&:not(:disabled):not(.disabled).active:focus {
		box-shadow: none;
	}
}
</style>
